import React, { memo } from "react"
import logo from "@images/black-impressit-logo.svg"
import { GLOBAL_APPLICATION_INTERNAL_LINKS } from "../../../../../../links"
import { useHeaderConfiguration } from "../../hooks"
import { IMPRESSIT_LOGO_ALT_TEXT, IMPRESSIT_LOGO_ARIA_LABEL } from "../../constants"
import { BurgerMenu, NavButtons } from "./components"
import {
  StyledHeaderWrapper,
  StyledHeaderContainer,
  StyledLogoLinkContainer,
  StyledLogoLink,
  StyledLogoIcon,
  StyledTextContainer,
  StyledActionsContainer,
} from "./styled"

const Header = ({
  headerTitle = (
    <p>
      Welcome to <strong>impressit</strong>
    </p>
  ),
  showLinks,
  handleClick,
  openMobileFilters,
  setOpenMobileFilters,
  path,
  setShowLinks,
}) => {
  const { currentOpacity, isDesktop, isMobile } = useHeaderConfiguration()

  return (
    <StyledHeaderWrapper currentOpacity={currentOpacity}>
      <StyledHeaderContainer>
        <StyledLogoLinkContainer>
          <StyledLogoLink aria-label={IMPRESSIT_LOGO_ARIA_LABEL} to={GLOBAL_APPLICATION_INTERNAL_LINKS.HOME}>
            <StyledLogoIcon src={logo} alt={IMPRESSIT_LOGO_ALT_TEXT} />
          </StyledLogoLink>
          {!isMobile && <StyledTextContainer>{headerTitle}</StyledTextContainer>}
        </StyledLogoLinkContainer>
        <StyledActionsContainer>
          {isDesktop && <NavButtons />}
          <BurgerMenu
            setShowLinks={setShowLinks}
            path={path}
            handleClick={handleClick}
            showLinks={showLinks}
            openMobileFilters={openMobileFilters}
            setOpenMobileFilters={setOpenMobileFilters}
          />
        </StyledActionsContainer>
      </StyledHeaderContainer>
    </StyledHeaderWrapper>
  )
}

export default memo(Header)
